module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABHElEQVRoQ+2Y3Q3CMAyE7yaAUWACGAE2oBPAKDAB3QBGKBPAKkxwyBIP/EmtSKQ4lS31rXHs+5w6NVG5sfL4EQmUJhgEgkCiAlFCiQImLx8nAUlLAItkefI6uJDsPl1+EZA0A3DNu3c2b3OSt1dvvxLYADhm2zKvo4Zk25fAFMAewArAJO/+f3u7AziTNHHfbJyH+G+dCiwMAgVEjzNQWvQg4J+ApO2zkXkK1hrZobeRSbIOfPIU+Ussa5LnvqtE3QlYdpJ2TkvI7mjxFXJ1POIuVBpHEAgCiQqMr4Qk2U+9TSWsI3uylmTT28gkVT9WqXuw9bwL2WjRHk/WDRoteop4SCzj+woNydrTO0GgNI0gEAQSFYgSShQwefkDvQQ9MV06qwsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = F3CK
// module chunks = 0